import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Award, Printer, Download, Star } from 'lucide-react';
import { Button } from '../components/ui/button';
import { brand } from '../mock';

export default function CertificatePage() {
  const [params] = useSearchParams();
  const name = params.get('name') || 'Student Name';
  const quiz = params.get('quiz') || 'Quiz';
  const score = params.get('score') || '0';
  const dateStr = new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });

  const handlePrint = () => setTimeout(() => window.print(), 200);

  return (
    <div className="px-4 pt-4 pb-8">
      <div className="no-print space-y-3">
        <Link to="/quiz" className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-emerald-600 font-medium">
          <ArrowLeft size={16} /> Back
        </Link>
        <div className="flex gap-2">
          <Button onClick={handlePrint} className="flex-1 h-11 rounded-2xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold gap-2">
            <Download size={17} /> A4 Certificate ଡାଉନଲୋଡ
          </Button>
          <Button onClick={handlePrint} variant="outline" className="h-11 rounded-2xl gap-2">
            <Printer size={16} /> Print
          </Button>
        </div>
      </div>

      {/* A4 Landscape Certificate */}
      <div className="print-page mt-5 bg-white rounded-3xl border-8 border-amber-500 shadow-2xl p-8 relative overflow-hidden" style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, rgba(245,158,11,0.08) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(5,150,105,0.06) 0%, transparent 50%)' }}>
        <div className="absolute inset-0 border-4 border-emerald-500 rounded-3xl m-2 pointer-events-none" />
        <div className="absolute top-4 left-4 text-amber-400 opacity-30"><Star size={32} className="fill-amber-400" /></div>
        <div className="absolute top-4 right-4 text-amber-400 opacity-30"><Star size={32} className="fill-amber-400" /></div>
        <div className="absolute bottom-4 left-4 text-emerald-400 opacity-30"><Star size={28} className="fill-emerald-400" /></div>
        <div className="absolute bottom-4 right-4 text-emerald-400 opacity-30"><Star size={28} className="fill-emerald-400" /></div>

        <div className="relative text-center">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 text-white flex items-center justify-center mx-auto shadow-lg">
            <Award size={32} />
          </div>
          <div className="mt-3 text-xs font-bold text-emerald-700 tracking-widest uppercase">Certificate of Achievement</div>
          <h1 className="text-3xl font-extrabold text-gray-900 mt-1" style={{ fontFamily: 'Georgia, serif' }}>{brand.name}</h1>
          <div className="text-[11px] text-gray-500">{brand.nameOdia}</div>

          <div className="mt-6 text-sm text-gray-700 italic">This certificate is proudly presented to</div>
          <div className="mt-2 text-2xl font-extrabold text-emerald-700" style={{ fontFamily: 'Georgia, serif', textDecoration: 'underline', textDecorationColor: '#f59e0b', textUnderlineOffset: '6px' }}>
            {name}
          </div>

          <div className="mt-4 text-sm text-gray-700 leading-relaxed max-w-md mx-auto">
            for successfully completing the <strong>{quiz}</strong> quiz on Gurusevakendra with an outstanding score of
          </div>
          <div className="mt-3 inline-block px-6 py-2 rounded-full bg-gradient-to-r from-emerald-500 to-teal-600 text-white text-2xl font-extrabold shadow-md">
            {score}%
          </div>

          <div className="mt-6 flex items-center justify-between text-xs text-gray-600 border-t border-gray-200 pt-4 max-w-md mx-auto">
            <div>
              <div className="font-bold text-gray-800">Date</div>
              <div>{dateStr}</div>
            </div>
            <div className="text-center">
              <div className="italic text-lg text-emerald-700" style={{ fontFamily: 'Georgia, serif' }}>Guru</div>
              <div className="border-t border-gray-400 pt-0.5 mt-0.5 font-bold">Authorized</div>
            </div>
            <div className="text-right">
              <div className="font-bold text-gray-800">ID</div>
              <div className="font-mono">{Date.now().toString(36).toUpperCase()}</div>
            </div>
          </div>

          <div className="mt-3 text-[10px] text-gray-500">🇮🇳 Made with ♥ for Odisha students · {brand.email}</div>
        </div>
      </div>
    </div>
  );
}
